<template>
  <div class="file-card-item">
    <img
      v-if="type === fileType.IMAGE"
      class="file-image"
      :src="file.url"
      alt=""
      @click="handlePreview"
    >
    <video
      v-else-if="type === fileType.VIDEO"
      class="file-video"
      @click="handlePreview"
    >
      <source :src="file.url">
    </video>
    <audio
      v-else-if="type === fileType.AUDIO"
      class="file-audio"
      :src="file.url"
      controls
    />
    <img
v-else
class="file-other"
src="../../assets/images/doc.webp"
alt="">
    <p
      v-if="showName"
      class="text-center my-2xs text-limited"
      :title="file.name"
    >
      {{ file.name }}
    </p>
    <el-dialog
      v-if="previewVisible"
      :visible.sync="previewVisible"
      append-to-body
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <img
        v-if="type === fileType.IMAGE"
        width="100%"
        :src="file.url"
        alt=""
        style="object-fit: contain"
      >
      <video
        v-else-if="type === fileType.VIDEO"
        width="400"
        height="500"
        controls
        class="w-100"
        autoplay
      >
        <source :src="file.url">
      </video>
    </el-dialog>
  </div>
</template>

<script>
import constants from "@/config/constants";

export default {
  name: "FileCard",
  props: {
    file: Object,
    type: String,
    showName: Boolean,
  },
  data() {
    return {
      fileType: constants.FILE_TYPE,
      previewVisible: false,
    };
  },
  methods: {
    handlePreview() {
      this.previewVisible = true;
    },
  },
};
</script>
